import React from 'react'
import HeaderTitle from '../../Molecules/HeaderTitle/HeaderTitle'
import FormCategory from '../../Organisms/FormCategory/FormCategory'

const EditCategory = () => {
  return (
    <div className="nd-grid">
      <HeaderTitle headerText="Editar categoría" withDivider />
      <div className="box s-pxy-20 m-pxy-50">
        <FormCategory isEditCategory />
      </div>
    </div>
  )
}

export default EditCategory
